<template>
  <FullScreenDialog
    v-model="dialog"
    without-padding
    title="Condizioni di pagamento"
    :route-father="routeFather"
  >
    <template v-slot:header-actions>
      <v-btn text link @click="goToNew">
        <v-icon class="mr-2">mdi-plus</v-icon> Nuovo
      </v-btn>
    </template>
    <template v-slot:toolbar-extension>
      <div class="d-flex justify-center align-center" style="width: 100%">
        <SearchBar
          class="ml-2 mb-2"
          placeholder="Cerca condizioni di pagamento ..."
          :search-icon="null"
          expand-on-focus
        ></SearchBar>
      </div>
    </template>
    <template v-slot:content>
      <div style="height: 100%; overflow-y: hidden" ref="dataTableWrapper">
        <TypeDataTable
          v-model="selected"
          loading-text="Caricamento condizioni di pagamento ..."
          :headers="headers"
          :loading="loading"
          :items="filteredPaymentConditions"
          :page.sync="page"
          :row-per-page.sync="rowPerPage"
          :total-pages.sync="totalPages"
          :height="dataTableHeight"
          @edit="handleEdit"
          @delete="handleDelete"
        >
        </TypeDataTable>
      </div>
    </template>
  </FullScreenDialog >
</template>

<script>
import FullScreenDialog from '@/components/common/FullScreenDialog.vue'
import StandardMenu from '@/components/common/StandardMenu.vue'
import TypeDataTable from '@/components/common/TypeDataTable.vue'
import { SearchBar } from "likablehair-ui-components";
import paymentConditionsService from '@/services/paymentTerms/paymentConditions.service.js'

export default {
  name: "PaymentConditionsList",
  components: {
    FullScreenDialog,
    SearchBar,
    TypeDataTable,
    StandardMenu
  },
  data: function() {
    let props = this.$router.resolve({name: 'Payments'});

    return {
      dialog: true,
      loadingItems: false,
      loadingHeaders: false,
      routeFather: props.href,
      selected: undefined,
      dataTableHeightValue: 400,
      paymentConditions: [],
      headers: [],
      page: 1,
      rowPerPage: 20,
      totalPages: 0,
      resizeListener: undefined
    }
  },
  mounted: function() {
    this.fetchHeaders()
    this.fetchPaymentConditions()

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    this.resizeListener = function() {
      this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    }
    this.resizeListener = this.resizeListener.bind(this)
    window.addEventListener('resize', this.resizeListener)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    fetchPaymentConditions() {
      this.loadingItems = true
      paymentConditionsService.list(this.page, this.rowPerPage).then((results) => {
        if(this.rowPerPage != results.rowPerPage) {
          this.rowPerPage = results.rowPerPage
        }

        if(this.page != results.page) {
          this.page = results.page
        }

        this.totalPages = results.totalPages
        if(this.totalPages < this.page && this.totalPages != 0) {
          this.page = this.totalPages
        }

        this.paymentConditions = results.rows
        this.loadingItems = false
      })
    },
    fetchHeaders() {
      this.loadingHeaders = true
      paymentConditionsService.fields().then((headers) => {
        this.headers = headers
        this.loadingHeaders = false
      })
    },
    handleEdit(paymentCondition) {
      this.$router.push({
        name: 'PaymentConditionsEditForm',
        params: {
          id: paymentCondition.id
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'PaymentConditionsList'}).href
        }
      })
    },
    handleDelete(paymentCondition) {
      let confirmed = confirm('Sei sicuro di voler eliminare la condizione di pagamento?')

      if(confirmed) {
        this.loading
        paymentConditionsService.delete(paymentCondition).then(() => {
          this.fetchPaymentConditions()
          this.loading 
        })
      }
    },
    goToNew() {
      this.$router.push({
        name: 'PaymentConditionsNewForm',
        query: {
          pathToGoBack: this.$router.resolve({name: 'PaymentConditionsList'}).href
        }
      })
    }
  },
  computed: {
    filteredPaymentConditions() {
      return this.paymentConditions
    },
    loading() {
      return this.loadingItems || this.loadingHeaders
    },
    dataTableHeight() {
      return this.dataTableHeightValue + 'px'
    }
  },
  watch: {
    page() {
      this.fetchPaymentConditions()
    },
    rowPerPage() {
      this.fetchPaymentConditions()
    },
  }
}
</script>